import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { map, tap, switchMap } from 'rxjs/operators';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
const TOKEN_KEY = environment.storageToken;
const URL = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private authService: AuthService, private http: HttpClient) {}

  login(data: any): Observable<any> {
    return this.http.post<any>(`${URL}/auth/login`, data);
  }

  logout(): void {
    this.authService.logout();
  }
}
